import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { EditModeService } from 'src/app/services/edit-mode/edit-mode.service';

@Component({
    selector: 'xqnr-q-name-field',
    templateUrl: './q-name-field.component.pug',
    styleUrls: ['./q-name-field.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class QNameFieldComponent implements OnInit {

  @Input() title = '';

  @Output() titleChanged = new EventEmitter();

  qName = new FormControl('', Validators.required);

  fa = {
    edit: faEdit
  };

  constructor(
    public editMode: EditModeService
  ) {}

  ngOnInit(): void {
    this.qName.setValue(this.title);

    this.qName.valueChanges
    .pipe(
      distinctUntilChanged(),
      debounceTime(300)
    ).subscribe(
      this.handleTitleChange
    );
  }

  handleTitleChange = () => {
    this.titleChanged.emit(this.qName.value);
  };
}
